import React from 'react';
import { Route, IndexRoute } from 'react-router';

import CoreLayout from 'tip/layouts/CoreLayout';

import ChaptersPage from 'tip/pages/ChaptersPage';
import AddChapterPage from 'tip/pages/AddChapterPage';
import ParagraphPage from 'tip/pages/ParagraphPage';

export default (store, tip) => (
  <Route path="/" components={CoreLayout} tip={tip}>
    <IndexRoute component={ChaptersPage} />
    <Route path="chapters/new" component={AddChapterPage} />
    <Route path="chapters/:id/paragraphs/new" component={ParagraphPage} />
    <Route path="paragraphs/:paragraph" component={ParagraphPage} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/modules/tip/routes/index.js